(() => {
  const initGalleryArrows = (root = document) => {
    root.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.tfGalleryArrowsReady === 'true') return;

      const viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
      const prevButton = viewer?.querySelector('button[name="previous"]');
      const nextButton = viewer?.querySelector('button[name="next"]');

      if (!viewer || !prevButton || !nextButton || typeof gallery.setActiveMedia !== 'function') return;

      gallery.dataset.tfGalleryArrowsReady = 'true';

      const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');

      const getItems = () => {
        const thumbnailItems = thumbnails
          ? Array.from(thumbnails.querySelectorAll('[data-target]')).filter((item) => item.dataset.target)
          : [];

        if (thumbnailItems.length > 1) return thumbnailItems;

        return Array.from(viewer.querySelectorAll('[data-media-id]')).filter((item) => item.dataset.mediaId);
      };

      const getActiveIndex = (items) => {
        const activeThumbnailIndex = items.findIndex((item) => item.querySelector('button[aria-current="true"]'));
        if (activeThumbnailIndex >= 0) return activeThumbnailIndex;

        const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
        return activeIndex >= 0 ? activeIndex : 0;
      };

      const syncButtonState = () => {
        prevButton.removeAttribute('disabled');
        nextButton.removeAttribute('disabled');
        prevButton.setAttribute('aria-disabled', 'false');
        nextButton.setAttribute('aria-disabled', 'false');
      };

      const goToMedia = (direction) => {
        const items = getItems();
        if (items.length < 2) return;

        const currentIndex = getActiveIndex(items);
        const nextIndex = (currentIndex + direction + items.length) % items.length;
        const target = items[nextIndex];
        const targetMediaId = target.dataset.target || target.dataset.mediaId;

        if (!targetMediaId) return;

        gallery.setActiveMedia(targetMediaId, false);

        const activeMedia = viewer.querySelector(`[data-media-id="${targetMediaId}"]`);
        if (!activeMedia) return;

        viewer.resetPages?.();
        viewer.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: nextIndex + 1,
              currentElement: activeMedia,
            },
          })
        );

        window.pauseAllMedia?.();
        activeMedia.querySelector('.deferred-media')?.loadContent(false);
        syncButtonState();
      };

      prevButton.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          goToMedia(-1);
        },
        true
      );

      nextButton.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          goToMedia(1);
        },
        true
      );

      viewer.addEventListener('slideChanged', syncButtonState);
      syncButtonState();
    });
  };

  const initModalArrows = (root = document) => {
    root.querySelectorAll('product-modal.product-media-modal').forEach((modal) => {
      if (modal.dataset.tfModalArrowsReady === 'true') return;

      const content = modal.querySelector('.product-media-modal__content');
      const prevButton = modal.querySelector('[data-tf-product-modal-prev]');
      const nextButton = modal.querySelector('[data-tf-product-modal-next]');

      if (!content || !prevButton || !nextButton) return;

      modal.dataset.tfModalArrowsReady = 'true';

      const controls = [prevButton, nextButton];
      controls.forEach((button) => {
        ['pointerdown', 'pointerup', 'click'].forEach((eventName) => {
          button.addEventListener(eventName, (event) => event.stopPropagation(), true);
        });
      });

      const getItems = () => Array.from(content.querySelectorAll('[data-media-id]'));

      const getActiveIndex = (items) => {
        const activeIndex = items.findIndex((item) => item.classList.contains('active'));
        return activeIndex >= 0 ? activeIndex : 0;
      };

      const goToMedia = (direction) => {
        const items = getItems();
        if (items.length < 2) return;

        const currentIndex = getActiveIndex(items);
        const nextIndex = (currentIndex + direction + items.length) % items.length;
        const target = items[nextIndex];

        items.forEach((item) => item.classList.remove('active'));
        target.classList.add('active');
        if (window.matchMedia('(min-width: 750px)').matches) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
        } else {
          content.scrollTo({ top: 0, left: 0 });
        }

        window.pauseAllMedia?.();
        if (target.nodeName === 'DEFERRED-MEDIA' || target.classList.contains('deferred-media')) {
          target.loadContent?.(false);
        }
      };

      prevButton.addEventListener('click', (event) => {
        event.preventDefault();
        goToMedia(-1);
      });

      nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        goToMedia(1);
      });

      modal.addEventListener('keydown', (event) => {
        if (!modal.hasAttribute('open')) return;
        if (event.key === 'ArrowLeft') goToMedia(-1);
        if (event.key === 'ArrowRight') goToMedia(1);
      });
    });
  };

  const boot = () => {
    customElements.whenDefined('media-gallery').then(() => initGalleryArrows());
    customElements.whenDefined('product-modal').then(() => initModalArrows());
  };

  document.addEventListener('shopify:section:load', (event) => {
    initGalleryArrows(event.target);
    initModalArrows(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
